import * as React from "react";
import { createModule } from "../config.js";
import { EventsProvider, LightboxStateProvider, TimeoutsProvider } from "../contexts/index.js";
import { MODULE_CORE } from "../consts.js";
export function Core({ slides, index, children }) {
    return (React.createElement(TimeoutsProvider, null,
        React.createElement(EventsProvider, null,
            React.createElement(LightboxStateProvider, { slidesCount: slides.length, initialIndex: index }, children))));
}
export const CoreModule = createModule(MODULE_CORE, Core);
